module.exports = __webpack_public_path__ + "static/media/enderezar.18cb7498.svg";